import React from "react";
import CopyrightSocial from "./CopyrightSocial";
import Copyright from "./Copyright";
import FooterAddress from "./FooterAddress";
import FooterMenuList from "./FooterMenuList";

const Footer = () => {
    return (
        <footer className="vcamp-footer-seven">
            <div className="container">
                <div className="row justify-between">
                    <div className="col-xl-4 col-lg-4 mb-40">
                        <h2 className="intro ">
                            <strong className="text-purple">Power</strong><strong className="text-green">Bizz </strong>
                        </h2>
                        <ul className="d-flex social-icon style-none">
                            <CopyrightSocial />
                        </ul>
                    </div>
                    <FooterMenuList />
                    {/* <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-5 mb-40">
                        <FooterAddress />
                    </div> */}
                </div>
            </div>
            <div className="container">
                <Copyright />
            </div>
        </footer>
    );
};

export default Footer;
